import React, { useState } from 'react';

const NameInput = ({ onSubmit, onBack, action }) => {
  const [playerName, setPlayerName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (playerName.trim()) {
      onSubmit(playerName.trim());
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">🃏 Last Card</h1>
          <p className="text-gray-400 mb-4">
            {action === 'create' ? 'Enter your name to create a game' : 'Enter your name to join the game'}
          </p>
        </div>

        {/* Name Input Form */}
        <div className="bg-gray-800 rounded-xl p-6 shadow-2xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="playerName" className="block text-sm font-medium text-gray-300 mb-2">
                Your Name
              </label>
              <input
                type="text"
                id="playerName"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                placeholder="Enter your name..."
                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                required
                autoFocus
                maxLength={20}
              />
              <p className="text-gray-400 text-sm mt-2">
                This name will be displayed to other players
              </p>
            </div>
            
            <div className="flex space-x-3">
              <button
                type="button"
                onClick={onBack}
                className="flex-1 btn btn-secondary"
              >
                ← Back
              </button>
              <button
                type="submit"
                disabled={!playerName.trim()}
                className="flex-1 btn btn-primary"
              >
                Continue →
              </button>
            </div>
          </form>
        </div>

        {/* Game Info */}
        <div className="mt-8 bg-gray-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">🎯 About Last Card</h3>
          <div className="space-y-2 text-sm text-gray-300">
            <p>• Real-time 1v1 card game</p>
            <p>• Match suits and ranks to play</p>
            <p>• Special cards have unique effects</p>
            <p>• First to shed all cards wins!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NameInput; 